import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { AreaTools } from 'models/editor'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'

export const PredictiveReportTool: FC = () => {
    const { t } = useTranslation()
    const [{ areaTool }, mapEditorDispatch] = useMapEditorContext()

    return (
        <button
            data-selected={areaTool === AreaTools.PREDICTIVE_REPORT_TOOL ? true : undefined}
            onClick={() => {
                mapEditorDispatch.selectTool(AreaTools.PREDICTIVE_REPORT_TOOL)
                mapEditorDispatch.setWizard(MapEditorWizards.PREDICTIVE_REPORT_TOOL)
            }}
            aria-label={t('map.tools.predictive_report')}
        >
            <Tooltip label={t(`tooltips.maptools.reporte_predictivo`)} direction="LEFT_CENTER">
                <Icon name="focus-2-line" />
            </Tooltip>
        </button>
    )
}


PredictiveReportTool.displayName = 'PredictiveReportTool'
